import { ClientTheme } from './models/client.model';

export const CLIENT_THEME: ClientTheme = {
  documentTitleText: "Clear Sign | eSign Platform",
  faviconUri: "/favicon.ico",
  logoLargeUri: "/assets/images/clearsignlogo.png",
  logoSmallUri: "/assets/images/clearsignlogo.png",
  primaryColorHexCode: "#111111",
  primaryColorHoverBgHexCode: "#DE3341",
  primaryColorHoverTextHexCode: "#FFFFFF",
  secondaryColorHexCode: "#111111",
  secondaryColorHoverBgHexCode: "#F2F2F2",
  secondaryColorHoverTextHexCode: "#FFFFFF",
  sessionEndTheme: null,
};
